import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Hi, I'm Ibibo Seleye-Fubara`}</h2>
    <p>{`I am a Software Engineer and technical writer read my `}<a parentName="p" {...{
        "href": "https://ibdaye.hashnode.dev"
      }}>{`blog here`}</a>{` and see `}<a parentName="p" {...{
        "href": "https://github.com/ibdaye?tab=repositories"
      }}>{`my github `}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      